import type { RouteObject } from "react-router-dom"

import { LoginPageContextProvider } from "@contexts/public/login_page_context"
import PublicLayout from "@layouts/public_layout"
import ErrorPage from "@pages/error"
import LoginPage from "@pages/public/login"

const publicNavigation: RouteObject[] = [
  {
    path: "/public/login",
    element: (
      <PublicLayout>
        <LoginPageContextProvider>
          <LoginPage />
        </LoginPageContextProvider>
      </PublicLayout>
    ),
    errorElement: <ErrorPage />
  }
]

export default publicNavigation
